var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 0.666748H20.3333C20.687 0.666748 21.0261 0.807224 21.2761 1.05727C21.5262 1.30732 21.6667 1.64646 21.6667 2.00008V27.5241C21.6668 27.6433 21.635 27.7604 21.5745 27.8631C21.5141 27.9658 21.4272 28.0505 21.3229 28.1082C21.2186 28.1659 21.1007 28.1946 20.9815 28.1913C20.8624 28.188 20.7463 28.1528 20.6453 28.0894L11 22.0401L1.35466 28.0881C1.25382 28.1514 1.13784 28.1866 1.0188 28.19C0.89975 28.1933 0.781976 28.1648 0.677722 28.1072C0.573467 28.0496 0.486537 27.9652 0.425972 27.8626C0.365407 27.7601 0.333417 27.6432 0.333328 27.5241V2.00008C0.333328 1.64646 0.473804 1.30732 0.723853 1.05727C0.973901 0.807224 1.31304 0.666748 1.66666 0.666748ZM5.66666 10.0001V12.6667H16.3333V10.0001H5.66666Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.dac11dc43c5cf4c88c54bfe1a127f059.svg";
export { ForwardRef as ReactComponent };